import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, Menu, MenuItem, List, ListItem, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import emojiToolkit from 'emoji-toolkit';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 300,
    },
    listSection: {
        backgroundColor: 'inherit',
    },
    ul: {
        backgroundColor: 'inherit',
        padding: 0,
    },
    listItem: {
        display: 'flex',
        width: '100%',
        minWidth: '210px',
        justifyContent: 'space-between',
        padding: '8px 16px',
        alignItems: 'center',
    },
    emoji: {
        margin: '0!important',
        padding: '0!important',
        display: 'inline-block',
        '& img': {
            width: '17px',
            height: '100%',
            margin: '0.5rem',
        }
    },
    extraCount: {
        fontSize: '15px',
        padding: '0 2px',
    }
}));

const EmojiGroup = ({ reactions, max = 0, message, onRemove }) => {
    const classes = useStyles({ fromMe: message.fromMe });
    const [anchorEl, setAnchorEl] = useState(null);
    const boxRef = useRef(null);

    // Uma entrada por pessoa/reação (não agrupar só por emoji: senão várias pessoas com o mesmo emoji viram uma só na faixa).
    const list = Array.isArray(reactions) ? reactions : [];
    const displayedReactions = max > 0 ? list.slice(0, max) : list;
    const overflow = max > 0 ? Math.max(0, list.length - max) : 0;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickOutside = (event) => {
        if (boxRef.current && !boxRef.current.contains(event.target)) {
            handleClose();
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <div style={{
            borderRadius: '25px',
            border: '1px solid #bbb6b6',
            position: 'absolute',
            zIndex: Boolean(anchorEl) ? '0' : '1200',
            backgroundColor: "white",
            padding: '2px 5px',
            left: message.fromMe ? '10px' : 'auto',
            right: message.fromMe ? 'auto' : '10px'
        }}>
            <Box ref={boxRef} display="flex" alignItems="center" onClick={handleClick} style={{ cursor: 'pointer', margin: '0!important', padding: '0!important' }}>
                {displayedReactions.map((item, index) => (
                    <React.Fragment key={`${item?.number || ''}-${item?.reaction || ''}-${index}`}>
                        <div
                            className={classes.emoji}
                            dangerouslySetInnerHTML={{ __html: emojiToolkit.toImage(item.reaction) }}
                        >
                        </div>
                    </React.Fragment>
                ))}
                {overflow > 0 && (
                    <Typography variant="h6" component="span" color="textSecondary" className={classes.extraCount}>
                        +{overflow}
                    </Typography>
                )}
                <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                    <List className={classes.root}>
                        {list.map((item, index) => (
                            <ListItem key={index} className={classes.listItem}>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    color="textPrimary"
                                >
                                    {item.name}
                                </Typography>
                                <Box>
                                    <div
                                        className={classes.emoji}
                                        dangerouslySetInnerHTML={{ __html: emojiToolkit.toImage(item.reaction) }}
                                    >
                                    </div>
                                    {item.fromMe && <IconButton onClick={() => onRemove()} aria-label="delete"><DeleteIcon /></IconButton>}
                                </Box>
                            </ListItem>
                        ))}
                    </List>
                </Menu>
            </Box>
        </div>
    );
};

export default EmojiGroup;
